export default __webpack_public_path__ + "static/mobile-1de251c63d72b4e06f5484af6d6a29e1.svg";